export enum WheelAction {
  TD = 'TD',
  Safety = 'SF',
  Simple = 'SIMPLE',
}

export interface WheelActionCallbacks {
  touchdown: () => void;
  simple: () => void;
  safety: () => void;
  reinit: () => void;
}
